export function rtkInvalidateOn<T>({
  success = [],
  error = [],
}: {
  success: T[];
  error: T[];
}): (result: unknown) => T[] {
  return (result: unknown) => (result ? success : error);
}
